import React from "react";

const InfoLogo = () => {
  return (
    <div>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.06892 11.2727C8.90536 11.2879 8.74114 11.251 8.59983 11.1672C8.49658 11.0612 8.44708 10.9141 8.4653 10.7672C8.46911 10.645 8.48371 10.5233 8.50892 10.4036C8.53333 10.2663 8.56486 10.1303 8.60346 9.99632L9.03255 8.51994C9.0768 8.37422 9.10605 8.22435 9.11983 8.07266C9.11983 7.90903 9.14164 7.79628 9.14164 7.73085C9.15077 7.43919 9.02624 7.15932 8.80346 6.97085C8.52942 6.76047 8.18817 6.65707 7.84346 6.67994C7.59642 6.68366 7.3513 6.7241 7.11617 6.79994C6.85921 6.87994 6.58889 6.97569 6.30527 7.08722L6.18164 7.56722C6.26527 7.53813 6.36711 7.50541 6.48346 7.46903C6.59446 7.43616 6.70952 7.419 6.82527 7.41813C6.98764 7.40053 7.15108 7.44041 7.28708 7.53085C7.37946 7.64107 7.4228 7.78425 7.40708 7.92722C7.40667 8.0495 7.39327 8.17141 7.36708 8.29085C7.34161 8.41813 7.30889 8.55266 7.26889 8.69447L6.83617 10.1781C6.8013 10.316 6.77339 10.4556 6.75255 10.5963C6.73555 10.7168 6.72705 10.8383 6.72708 10.9599C6.7253 11.2536 6.85958 11.5315 7.09071 11.7126C7.36896 11.9263 7.71508 12.0322 8.06524 12.0108C8.3118 12.0159 8.55752 11.9803 8.79252 11.9053C8.99858 11.835 9.27374 11.7344 9.61799 11.6035L9.73436 11.1453C9.64111 11.184 9.54508 11.2156 9.44708 11.2399C9.32314 11.2682 9.19589 11.2792 9.06892 11.2727Z"
          fill="#606060"
        />
        <path
          d="M9.5237 4.27275C9.32579 4.091 9.06504 3.99322 8.79641 4.00003C8.52795 3.99397 8.26745 4.09165 8.06913 4.27275C7.70563 4.58618 7.66504 5.13497 7.97851 5.4985C8.00645 5.5309 8.03673 5.56118 8.06913 5.58912C8.48326 5.95953 9.10957 5.95953 9.52366 5.58912C9.88716 5.27259 9.92526 4.72134 9.60873 4.35784C9.58241 4.32756 9.55398 4.29912 9.5237 4.27275Z"
          fill="#606060"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM0.727281 8C0.727281 12.0166 3.98338 15.2727 8 15.2727C12.0166 15.2727 15.2727 12.0166 15.2727 8C15.2727 3.98338 12.0166 0.727281 8 0.727281C3.98338 0.727281 0.727281 3.98338 0.727281 8Z"
          fill="#606060"
        />
      </svg>
    </div>
  );
};

export default InfoLogo;
